import { Center, Flex, LinkOverlay, SimpleGrid, Image } from '@chakra-ui/react';
import { IFunctionsItems } from 'constants/allfunctions';
import { useCallback, memo } from 'react';
import { checkPermission } from 'utils/authentication';
import { openNotification } from 'utils/notification';
import { LabelText, LinkBox } from '../styles';

interface IGridCardsDefault {
  history: any;
  location?: any;
  match?: any;
  arrayFunctionItems: any[];
}

export const CardsDefaultAllFunctions: React.FC<IGridCardsDefault> = ({
  history,
  arrayFunctionItems,
}) => {
  const handleDispatchMessage = useCallback(
    (noAccess: boolean, e: React.MouseEvent<HTMLAnchorElement, MouseEvent> | any) => {
      e.preventDefault();
      openNotification(
        !noAccess
          ? 'Função indisponível. Estamos trabalhando para lançar esta função em breve!'
          : 'Você não possui acesso a esta função.',
        !noAccess ? 'info' : 'warn',
      );
    },
    [],
  );

  const isDisabled = useCallback((stat: IFunctionsItems) => {
    return !!(
      stat.disabled ||
      (stat.userType &&
        !checkPermission({
          onlyAdmin: stat.userType === 'admin',
          onlyClient: stat.userType === 'client',
        }))
    );
  }, []);

  return (
    <Flex mb="2em">
      <SimpleGrid columns={{ base: 1, md: 4 }} w="100%" gap="1rem">
        {arrayFunctionItems.map(stat => (
          <LinkBox $isDisabled={isDisabled(stat)} key={stat.label} w="100%" maxWidth="380px">
            <LinkOverlay
              onClick={
                isDisabled(stat)
                  ? handleDispatchMessage.bind(
                      null,
                      stat.disabled || !!stat.userType ? stat.isPage : false,
                    )
                  : e => {
                      e.preventDefault();
                      stat.route && history.push(stat.route);
                      window.scrollTo(0, 0);
                    }
              }
              href="#"
              style={{
                opacity: stat.disabled ? '0.5' : '1',
                cursor: stat.disabled ? 'default' : 'pointer',
              }}
            >
              <Flex position="relative" height={'2rem'}>
                <Center
                  borderRadius={'50%'}
                  left="0"
                  background={'#60DFDB'}
                  height="28px"
                  width="28px"
                ></Center>
                <Image
                  src={stat.iconString}
                  alt={stat.label}
                  position="absolute"
                  left={'10px'}
                  top={'10px'}
                  className="svgImage"
                />
              </Flex>
              <LabelText className="textLabel" mt={'4rem'} color="#22272D">
                {stat.label}
              </LabelText>
            </LinkOverlay>
          </LinkBox>
        ))}
      </SimpleGrid>
    </Flex>
  );
};

export const GridCardsDefault = memo(CardsDefaultAllFunctions);
